import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconImage.tsx
const OutlinedFilledImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm34-173h515L578-488 446-317l-93-127-130 176Z" })
});
const OutlinedImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm34-79h515L578-488 446-317l-93-127-130 176Zm-34 79v-582 582Z" })
});
const RoundedFilledImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm80-173h423q15.5 0 21.25-12.63Q719-293.25 711-306L597-462q-7.31-9-19.15-9.5Q566-472 559-462L446-317l-73-101q-8.31-10-20.15-9.5Q341-427 334-418l-83 112q-9 12.75-3.25 25.37Q253.5-268 269-268Z" })
});
const RoundedImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h582q39.46 0 67.23 27.77Q866-810.46 866-771v582q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm0-94h582v-582H189v582Zm0 0v-582 582Zm80-79h423q15 0 21-12.63 6-12.62-2-25.37L597-462q-7.31-9-19.15-9.5Q566-472 559-462L446-317l-73-101q-8.31-10-20.15-9.5Q341-427 334-418l-83 112q-9 12.75-3 25.37Q254-268 269-268Z" })
});
const SharpFilledImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M223-268h515L578-488 446-317l-93-127-130 176ZM95-95v-771h771v771H95Z" })
});
const SharpImage = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M223-268h515L578-488 446-317l-93-127-130 176ZM95-95v-771h771v771H95Zm94-94h582v-582H189v582Zm0 0v-582 582Z" })
});
const componentMap = {
	outlined: OutlinedImage,
	"outlined-fill": OutlinedFilledImage,
	rounded: RoundedImage,
	"rounded-fill": RoundedFilledImage,
	sharp: SharpImage,
	"sharp-fill": SharpFilledImage
};
const IconImage = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconImage };